import { FC, useRef } from "react";
import { Styled } from "./styled";
import usePDF, { IProps } from "./hook";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PDFLayout = (props: ReturnType<typeof usePDF>) => {
  const { uri, defaultLayoutPluginInstance } = props;

  return (
    <Styled>
      <div
        style={{
          width: "100%",
          height: "calc(100% - 40px)",
          overflow: "auto",
        }}
      >
        <Worker workerUrl="/pdf/pdf.worker.min.js">
          <div style={{ height: "100%", border: "1px solid #ccc" }}>
            <Viewer
              fileUrl={uri || ""}
              plugins={[defaultLayoutPluginInstance]}
              transformGetDocumentParams={(options) => {
                return {
                  ...options,
                  cMapUrl: "/cmaps/",
                  cMapPacked: true,
                };
              }}
            />
          </div>
        </Worker>
      </div>
    </Styled>
  );
};

const PDF: FC<IProps> = (props: IProps) => <PDFLayout {...usePDF(props)} />;

export default PDF;
